import React from 'react';

import useBreakpoint from '../../SharedUtils/hooks/useBreakpoint'; // ' ./useBreakpoint';

import '../styles/ResponsiveVideo.css';
/**
 * ResponsiveVideo Component
 *
 * Renders a video element whose source is determined by the current breakpoint.
 *
 * Props:
 * - videoSrc: Fallback video URL.
 * - videoSources: Optional object with URLs for different breakpoints:
 *     - small: Up to 600px wide.
 *     - medium: 601px to 1024px wide.
 *     - large: 1025px and wider.
 *     - default: Optional default if none of the breakpoints match.
 * - className: Optional CSS class for the video element.
 */
const ResponsiveVideo = ({ videoSrc, videoSources, className = 'masthead__video', ...rest }) => {
  const breakpoint = useBreakpoint();

  const currentSrc =
    (videoSources && videoSources[breakpoint]) ||
    (videoSources && videoSources.default) ||
    videoSrc;

  return (
    <video autoPlay loop muted className={className} {...rest}>
      <source src={currentSrc} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};

export default ResponsiveVideo;
